/** AUTO-GENERATED by download-fonts.ps1 - do not edit by hand. */
export const LOCAL_FONT_NAMES = [
  'Blast Bold Hollow',
  'Boingster',
  'Bw Surco',
  'cour',
  'Edirne-Normal_cyrillic',
  'Furore',
  'good vides pro',
  'josefkpaneuropean',
  'Monomakh',
  'Neuzeit Antiqua',
  'Preciosa',
  'Preciosa Valeria',
  'Rodondo RUS',
  'timesnewromanpsmt',
  'Tobi Greek',
  'Transita Modern',
  'VMVTZARCARI',
];
